<live-single-eventlist *ngIf="showLiveList" [_sportName]="'Soccer'" [_selectedOdds]="this._selectedOdds"></live-single-eventlist>

<div class="live-single-content">
  <div class="breadcrumb-container text" (click)="goBack()">
    <div class="breadcrumb-left">
      <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
    </div>
    <div class="breadcrumb-mid" *ngIf="this._DataHelper.selectedMatch">
      <div class="breadcrumb-tournament-name">
        <ng-container *ngIf="this._DataHelper.selectedMatch?.GroupName === ('MyBets' | t); else flag">
          <div class="breadcrumb-turnament-icon">
            <image-loader-utils url="my-bets" extraClasses="svg"></image-loader-utils>
          </div>
        </ng-container>
        <ng-template #flag>
          <div class="breadcrumb-turnament-icon">
            <image-loader-utils [url]="this._DataHelper.selectedMatch?.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
          </div>
        </ng-template>
        <strong class="template-name"> {{ this._DataHelper.selectedMatch?.GroupName }} </strong>
      </div>
    </div>
    <div class="breadcrumb-mid" *ngIf="!this._DataHelper.selectedMatch">
      <div class="breadcrumb-turnament-icon">
        <image-loader-utils url="sports" extraClasses="svg"></image-loader-utils>
      </div>
      <div class="breadcrumb-tournament-noname">
        <strong> {{ 'SPORTS' | t }} </strong>
      </div>
    </div>
    <div class="breadcrumb-right">
      <image-loader-utils url="star" [extraClasses]="'star-icon '"></image-loader-utils>
    </div>
  </div>

  <div class="b3000-scoreboard-container live-scoreboard text" *ngIf="showLiveList">
    <div class="box match-time">{{ this.event?.TimeStatuColor }} {{ this.event?.MatchTime }}</div>
    <div class="box first" (click)="addMatch2Favs()">
      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (isFavorite ? 'matchfavourited' : '')"></image-loader-utils>
    </div>
    <div class="box second">
      {{ this.event?.HomeTeam }}
    </div>
    <div class="box third">
      {{ this.event?.Score }}
    </div>
    <div class="box fourth">
      {{ this.event?.AwayTeam }}
    </div>
    <div class="box fifth" (click)="openHeadToHeadDialog()" *ngIf="-1 * this.eventid < 0">
      <image-loader-utils url="signal" extraClasses="signal-icon"></image-loader-utils>
    </div>
  </div>

  <ng-container [ngSwitch]="['cangobet'] | getProductName">
    <ng-container *ngSwitchCase="'cangobet'">
      <div *ngIf="isTracerMapped; else notMapped" id="lsSportWrapperElemCango"></div>
    </ng-container>

    <ng-template #notMapped>
      <div class="mappingNotAllowed">
        <div class="icon-svg" [inlineSVG]="'icons/noLive.svg' | getAssetsPath"></div>
      </div>
      <div class="mappingNotAllowed">
        {{ 'LSTracker_Missing' | t }}
      </div>
    </ng-template>

    <ng-container *ngSwitchDefault>
      <div class="widgets">
        <div><div class="sr-widget sr-widget-1"></div></div>
        <iframe *ngIf="this.enableBetGeniusTracker" scrolling="no" id="betgenius-iframe" [src]="this.betgeniustrackerlink" width="100%" height="289"></iframe>
      </div>
    </ng-container>
  </ng-container>
  <div class="event-detail-tab">
    <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 2 }" (click)="marketTypeChanged(2)">
      {{ 'OddsAll' | t }}
    </div>
    <!--<div class="event-detail-tab-item"
         [ngClass]="{ 'active' : selectedMarketValue == 1}"
         (click)="marketTypeChanged(1)">
      {{"OddsPopular"| t}}
    </div>-->
    <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 3 }" (click)="marketTypeChanged(3)">
      {{ 'OddsMatchResult' | t }}
    </div>
    <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 7 }" (click)="marketTypeChanged(7)">
      {{ 'OddsOverUnder' | t }}
    </div>
    <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 4 }" (click)="marketTypeChanged(4)">
      {{ 'OddsFirstHalf' | t }}
    </div>
    <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 6 }" (click)="marketTypeChanged(6)">
      {{ 'OddsAsia' | t }}
    </div>
  </div>
  <div class="event-detail-tab-content">
    <ng-container *ngFor="let oddType of this.eventdetailList | groupLiveOddsByName | sortBy : true : 'SeqNumber'; let i = index">
      <div class="event-detail-odd-box">
        <div class="event-detail-odd-title">
          {{ oddType.GroupName }}
        </div>
        <div class="event-detail-odd-content">
          <ng-container *ngFor="let odd of oddType.eOdds | sortBy : true : 'SeqNumber'">
            <div
              class="event-detail-odd-button"
              *ngIf="odd.BetStatus == 2"
              (click)="clickOdd(odd)"
              [ngClass]="{
                active: checkOddId(odd.OddId) === 'active',
                'btn-single': oddType.eOdds.length == 1,
                'btn-double': oddType.eOdds.length == 2,
                'btn-triple': oddType.eOdds.length == 3,
                'btn-multiple': oddType.eOdds.length > 3
              }">
              <div class="event-detail-odd-outcome">{{ odd.OutCome }}</div>
              <div class="event-detail-odd-value">
                {{ odd.OddValue | number : '1.2-2' }}
              </div>
            </div>
            <div
              class="event-detail-odd-button lock"
              [ngClass]="{
                'btn-single': oddType.eOdds.length == 1,
                'btn-double': oddType.eOdds.length == 2,
                'btn-triple': oddType.eOdds.length == 3,
                'btn-multiple': oddType.eOdds.length > 3
              }"
              *ngIf="odd.BetStatus != 2">
              <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
